import styled, { css } from "styled-components";
import photo1Dark from "assets/images/photo-1-dark.jpg";
import photo1Light from "assets/images/photo-1-light.jpg";
import photo2Dark from "assets/images/photo-2-dark.jpg";
import photo2Light from "assets/images/photo-2-light.jpg";
import photo3Dark from "assets/images/photo-3-dark.jpg";
import photo3Light from "assets/images/photo-3-light.jpg";
import photo4Dark from "assets/images/photo-4-dark.jpg";
import photo4Light from "assets/images/photo-4-light.jpg";
import { fonts } from "styles";
import { Theme } from "interfaces/theme";

export const Content = styled.section`
  width: 100%;
  max-width: 1280px;
  display: flex;
  column-gap: 40px;
  row-gap: 72px;
  margin: 0 auto 72px auto;
  perspective: 1000px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
    row-gap: 61px;
    margin: 0 auto;

    &:last-child {
      flex-direction: column-reverse;
      justify-content: center;
      row-gap: 61px;
      margin: 0 auto;
    }
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 582px;
  position: relative;
`;

export const FigureWrapper = styled.div`
  transition: 1s ease;
  transform-style: preserve-3d;
`;

export const Figure = styled.figure`
  margin-bottom: 24px;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const Legend = styled.legend`
  height: 24px;
  padding: 0 42px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 19px;
  text-align: center;
  color: #130c06;
  transition: 1s ease;

  @media screen and (max-width: 414px) {
    padding: 0;
    height: auto;
  }
`;

export const LegendLight = styled(Legend)``;
export const LegendDark = styled(Legend)`
  display: none;
`;

export const Photo1Light = styled.img.attrs({ src: photo1Light })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
  transition: 1s ease;
`;

export const Photo1Dark = styled.img.attrs({ src: photo1Dark })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
  transition: 1s ease;
  position: absolute;
  opacity: 0;
  z-index: 1;
`;

export const Photo2Light = styled.img.attrs({ src: photo2Light })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
`;

export const Photo2Dark = styled.img.attrs({ src: photo2Dark })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
  transition: 1s ease;
  position: absolute;
  opacity: 0;
  z-index: 1;
`;

export const Photo3Light = styled.img.attrs({ src: photo3Light })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
`;

export const Photo3Dark = styled.img.attrs({ src: photo3Dark })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
  transition: 1s ease;
  position: absolute;
  opacity: 0;
  z-index: 1;
`;

export const Photo4Light = styled.img.attrs({ src: photo4Light })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
`;

export const Photo4Dark = styled.img.attrs({ src: photo4Dark })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
  transition: 1s ease;
  position: absolute;
  opacity: 0;
  z-index: 1;
`;

interface IContainer {
  mode: Theme;
}
export const Container = styled.section<IContainer>`
  width: 100%;
  max-width: max-content;
  padding: 110px 24px;
  margin: 0 auto;

  @media screen and (max-width: 414px) {
    padding: 80px 24px;
  }

  ${({ mode }) =>
    mode === "dark" &&
    css`
      ${FigureWrapper} {
        /* transform: rotateY(180deg); */
      }
      ${Figure} {
        .dark {
          opacity: 1;
        }
      }
      ${Legend} {
        color: #fff;
      }
      ${LegendLight} {
        display: none;
      }
      ${LegendDark} {
        display: block;
      }
    `}
`;
